import styled, { DefaultTheme, css } from 'styled-components';
import { MAP_HEIGHT } from 'constants/styled.contants';
import vectorMinus from '../../../assets/img/vector-minus.svg';
import vectorMinusDisabled from '../../../assets/img/vector-minus-disabled.svg';
import vectorPlus from '../../../assets/img/vector-plus.svg';
import vectorPlusDisabled from '../../../assets/img/vector-plus-disabled.svg';
import circle from '../../../assets/img/circle.svg';

export const marginTop = 65;

const commonZoomButtonStyles = (theme: DefaultTheme) => css`
  width: ${theme.spacing.km8};
  height: ${theme.spacing.km8};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  border-width: ${theme.border.width.thinner};
  border-style: ${theme.border.style.solid};
  gap: 10px;
  box-shadow: 0px 4px 4px -2px rgba(38, 47, 74, 0.08);
  box-shadow: 0px 2px 4px -2px rgba(38, 47, 74, 0.12);

  + a {
    margin-top: ${theme.spacing.km2};
  }

  span {
    opacity: 0;
  }
`;

export const ContainerMap = styled.div<{ isLoaded: boolean; $zoomMaxDisabled: boolean; $zoomMinDisabled: boolean }>`
  ${({ theme, isLoaded, $zoomMaxDisabled, $zoomMinDisabled }) => css`
    width: 100%;
    height: ${MAP_HEIGHT}px;
    min-width: 312px;
    z-index: ${theme.zIndex.absolute};
    top: 208px;
    margin-bottom: ${theme.spacing.km4};
    ${
      !isLoaded &&
      css`
        opacity: 0;
        height: 0;
      `
    }

    .map {
      width: 100%;
      height: 100%;
      border-radius: ${theme.border.radius.small};
    }

    .avatar-icon {
      border-radius: ${theme.border.radius.circle};
    }
    .leaflet-right {
      right: ${theme.spacing.km2};
    }

    .leaflet-bottom {
      bottom: 6px;
    }

    && .leaflet-control-zoom {
      border: none;

      a.leaflet-control-zoom-out {
        ${commonZoomButtonStyles(theme)}
        border-color: ${$zoomMinDisabled ? theme.color.border.neutral.weak : theme.color.border.neutral.strong};
        background-color: ${
          $zoomMinDisabled ? `${theme.color.background.neutral.weak}` : `${theme.color.background.neutral.default}`
        };
        background-image: url(${$zoomMinDisabled ? vectorMinusDisabled : vectorMinus});
      }
      a.leaflet-control-zoom-in {
        ${commonZoomButtonStyles(theme)}
        border-color: ${$zoomMaxDisabled ? theme.color.border.neutral.weak : theme.color.border.neutral.strong};
        background-color: ${
          $zoomMaxDisabled ? `${theme.color.background.neutral.weak}` : `${theme.color.background.neutral.default}`
        };
        background-image: url(${$zoomMaxDisabled ? vectorPlusDisabled : vectorPlus});
       x
      }
    }

    .container-icon-avatar {
      ::before {
        content: '';
        background-image: url(${circle});
        background-repeat: no-repeat;
        background-size: cover;
        width: 48px;
        height: 48px;
        display: block;
        position: absolute;
        top: 0px;
        left: -23%;
      }

      &.active-marker,
      &.hover-journey-item-marker,
      .wrapper-icon {
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: ${theme.border.radius.circle};
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        img {
          min-height: 10px;
          min-width: 10px;
          object-fit: cover;
          overflow: hidden;
          margin-left: 2px;
          z-index: ${theme.zIndex.tooltip};
          margin-top: -2px;
        }
      }
    }
  `}
`;
